import React from "react";
import "./FileStatusBadge.css";
import { useTranslation } from "react-i18next";

type FileStatus = "uploaded" | "pending";

interface FileStatusBadgeProps {
  status: FileStatus;
}


export const FileStatusBadge: React.FC<FileStatusBadgeProps> = ({ status }) => {
  const { t } = useTranslation("common")
  return (
    <span className={`file-status-badge ${status}`}>
      {t(`file-upload.status-${status}`)}
    </span>
  );
};